import { breakpointsTailwind } from '@vueuse/core'

export default () => ({
  xs: 431,
  ...breakpointsTailwind,
})
